import moment from "moment";
import React, { Fragment } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postPecanForms } from "../../redux/actions/pecanActions";

const NextOfKinForm = ({ appData, postPecanFormsFunc }) => {
  const {
    firstName = "",
    lastName = "",
    address: { addressLine1, addressLine2, town, postcode, county },
    mobileTelephone = "",
    title,
  } = {
    address: {
      addressLine1: "",
      addressLine2: "",
      town: "",
      postcode: "",
      county: "",
    },
    ...appData,
  }; // in case that candidate has no address

  let initialData = {
    firstName,
    lastName,
    addressLine: addressLine1 + (addressLine2 ? `, ${addressLine2}` : ""),
    postTown: town,
    postCode: postcode,
    county,
    mobileNumber: mobileTelephone,
    Group22: title,
  };

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  if (
    appData.pecanOnboarding &&
    appData.pecanOnboarding.forms &&
    appData.pecanOnboarding.forms.nextOfKinForm
  ) {
    initialData = {
      ...initialData,
      ...appData.pecanOnboarding.forms.nextOfKinForm,
    };
  }

  const getVal = getField(initialData);

  const initialState = {
    blurb3: {
      htmlObj: <HorizontalLine text={"Employee Details"} />,
    },
    Group22: {
      title: "Title",
      type: "radio",
      value: getVal("Group22"),
      radioOptions: ["Mr", "Mrs", "Miss", "Ms"],
      mandatory: true,
    },
    firstName: {
      title: "First Name:",
      value: getVal("firstName"),
      mandatory: true,
    },
    lastName: {
      title: "Surname:",
      value: getVal("lastName"),
      mandatory: true,
    },
    addressLine: {
      title: "Address Line 1:",
      value: getVal("addressLine"),
      mandatory: true,
    },
    postTown: {
      title: "Town:",
      value: getVal("postTown"),
      mandatory: true,
    },
    county: {
      title: "County:",
      value: getVal("county"),
      mandatory: true,
    },
    postCode: {
      title: "Postcode:",
      value: getVal("postCode"),
      mandatory: true,
    },
    telephoneNumber: {
      title: "Telephone Number:",
      value: getVal("telephoneNumber"),
    },
    mobileNumber: {
      title: "Mobile Number:",
      value: getVal("mobileNumber"),
      mandatory: true,
    },
    blurb4: {
      htmlObj: <HorizontalLine text={"Next of Kin Details - First Contact"} />,
    },
    kinName: {
      title: "Name:",
      value: getVal("kinName"),
      mandatory: true,
    },
    kinRelationship: {
      title: "Relationship:",
      value: getVal("kinRelationship"),
      mandatory: true,
    },
    kinAddress: {
      title: "Address Line 1:",
      value: getVal("kinAddress"),
      mandatory: true,
    },
    kinTown: {
      title: "Town:",
      value: getVal("kinTown"),
      mandatory: true,
    },
    kinCounty: {
      title: "County:",
      value: getVal("kinCounty"),
    },
    kinPostcode: {
      title: "Postcode:",
      value: getVal("kinPostcode"),
      mandatory: true,
    },
    kinTelephoneNumber: {
      title: "Telephone Number:",
      value: getVal("kinTelephoneNumber"),
    },
    kinMobileNumber: {
      title: "Mobile Number:",
      value: getVal("kinMobileNumber"),
      mandatory: true,
    },
    blurb5: {
      htmlObj: <HorizontalLine text={"Next of Kin Details - Second Contact"} />,
    },
    kinName2: {
      title: "Name:",
      value: getVal("kinName2"),
      mandatory: true,
    },
    kinRelationship2: {
      title: "Relationship:",
      value: getVal("kinRelationship2"),
      mandatory: true,
    },
    kinAddress2: {
      title: "Address Line 1:",
      value: getVal("kinAddress2"),
      mandatory: true,
    },
    kinTown2: {
      title: "Town:",
      value: getVal("kinTown2"),
      mandatory: true,
    },
    kinCounty2: {
      title: "County:",
      value: getVal("kinCounty2"),
    },
    kinPostcode2: {
      title: "Postcode:",
      value: getVal("kinPostcode2"),
      mandatory: true,
    },
    kinTelephoneNumber2: {
      title: "Telephone Number:",
      value: getVal("kinTelephoneNumber2"),
    },
    kinMobileNumber2: {
      title: "Mobile Number:",
      value: getVal("kinMobileNumber2"),
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postPecanFormsFunc("nextOfKinForm", {
      ...fieldValuesPayload,
    });

    history.push("/profile/edit/onboarding-pecan");
  };

  return (
    <FormCreator
      formTitle={"Employee and Next of Kin Details"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/onboarding-pecan")}
      onboardingBranch={"pecan"}
    />
  );
};
NextOfKinForm.propTypes = {
  appData: any,
  postPecanFormsFunc: func.isRequired,
};
const mapDispatchToProps = {
  postPecanFormsFunc: postPecanForms,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(NextOfKinForm);
